"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { pageview } from "@/libs/gtag";

export function GaListener() {
  const pathname = usePathname();

  useEffect(() => {
    pageview(pathname);
  }, [pathname]);

  return null;
}
